/**
 * Angular Component BMProgressBar
 * Polyfill/Stylable progress bar
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

@Component({
  selector: 'bm-progress',
  templateUrl: 'progress-bar.component.html',
  styleUrls: ['progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  @HostBinding('attr.aria-valuemin') public readonly min = 0;
  @HostBinding('attr.role') public readonly role = 'progressbar';

  @HostBinding('attr.aria-valuemax')
  @Input()
  public max = 100;

  @HostBinding('attr.aria-valuenow')
  @Input()
  public set value(v: number) {
    this._value = Math.min(Math.max(0, Number.isNaN(v) ? 0 : v), this.max);
    this.innerWidth = Math.round((10000 * this._value) / this.max) / 100;

    this._cdr.markForCheck();
  }
  public get value() {
    return this._value;
  }

  /**
   * Sets if the bar should display or not an animation after value changes
   */
  @Input()
  @HostBinding('attr.static')
  public staticBar = false;

  public innerWidth!: number;

  private _value = 0;

  constructor(private _cdr: ChangeDetectorRef) {}
}
